import { Handle, Position } from "@xyflow/react";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";

function HandlePoint(props) {
  let optionsArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "#", "*"];
  function delteHandle(handleId) {
    console.log("here id is :" + handleId);
    props.onDel(handleId);
  }
  const [selpObj, setSelpObj] = useState(null);
  function updateHandle(event, handleId) {
    console.log(event);
    console.log(event.target.value);
    setSelpObj(handleId);
    if (props.onUpdate) props.onUpdate(event.target.value, handleId);
    setSelObj(event.target.value);
  }

  const [selObj, setSelObj] = useState(null);
  useEffect(() => {
    console.log("1111111111222333333333wwwwwwwwwww22222222222222");
    console.log(selpObj);
    setSelObj(selpObj);
  }, [props.oerr]);
  return (
    <>
      <Handle
        className=""
        type={props.type ? props.type : "source"}
        position={Position.Right}
        id={props.id}
        style={{
          visibility: props.visible ? "" : "hidden",
          top: props.top,
          right: -1,
          background: "#fff",
          height: 10,
          width: 10,
          border: "2px solid #288cd4"
        }}
        isConnectable={true}
      >
        {props.isselect && (
          <>
            <div className={props.handleClass}>
              <div>
                <select
                  className="handleselect nodeLinkIcon"
                  name="aa_options"
                  id={`options_${props.handleId}`}
                  onChange={(e) => updateHandle(e, props.handleId)}
                  value={selObj}
                >
                  {optionsArray &&
                    optionsArray.map((item, index) => (
                      <>
                        { }
                        <option value={item} selected={item == props.handleId}>
                          {item}
                        </option>
                      </>
                    ))}
                </select>
              </div>
              <div className="ms-2">
                {" "}
                {props.oerr && <p style={{ color: "red" }}>{props.oerr}</p>}
              </div>
              <div className="ms-3">
                <MDBBtn
                  size="sm"
                  className="p-0"
                  color="link"
                  onClick={(e) => {
                    delteHandle(props.handleId);
                  }}
                >
                  <MDBIcon fas icon="times" />
                </MDBBtn>
              </div>
            </div>
          </>
        )}
        {!props.isselect && (
          <>
            <div className={props.handleClass}>
              {props.label}
              {props.showAcount && (
                <>
                  <b>(26)</b>
                </>
              )}
              {props.deletable && (
                <div className="ms-3">
                  <div
                    size="sm"
                    className="p-0"
                    color="link"
                    onClick={(e) => {
                      delteHandle(props.handleId);
                    }}
                  >
                    <MDBIcon fas icon="times" color="primary" />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </Handle>
    </>
  );
}

export default HandlePoint;
